import React from 'react'
import { useTranslation } from 'react-i18next'
import { AvailabilitySlot, EventType } from '../../calendar-interface'
import { TimeFormatEnum } from '../../constants'
import { formatDate, isDatesEqual, secondsToHours } from '../../utils'
import { TimeSlotListUi } from './ui/time-slot-list-ui'
import { TimeSlotButtonUi } from './ui/time-slots-button-ui'
import { TimeSlotsWrapperUi } from './ui/time-slots-wrapper-ui'

interface TimeSlotsProps {
  availabilitySlots: AvailabilitySlot[]
  selectedTimeSlot?: number
  onTimeSlotSelect?: (timeSlot: number) => void
  selectedSlotBackgroundColor: string
  selectedDate: Date
  titlesColor: string
  timeFormat?: TimeFormatEnum
  eventType: EventType
}

export function TimeSlots({
  availabilitySlots,
  selectedTimeSlot,
  onTimeSlotSelect,
  selectedSlotBackgroundColor,
  selectedDate,
  titlesColor,
  timeFormat,
  eventType,
}: TimeSlotsProps) {
  const { t } = useTranslation()
  const selectedAvailability = availabilitySlots.find(({ date }) =>
    isDatesEqual(date, selectedDate),
  )
  const getTextForSlotsLeft = (value: number): string => {
    return value === 1
      ? `${value} ${t('entity_settings.booking_calendar.slot_left')}`
      : `${value} ${t('entity_settings.booking_calendar.slots_left')}`
  }

  return (
    <TimeSlotsWrapperUi>
      <span style={{ color: titlesColor, fontSize: 14 }}>
        {formatDate(selectedDate, t)}
      </span>
      <TimeSlotListUi>
        {selectedAvailability?.spots.map(({ startTime, remainingSlots }) => (
          <TimeSlotButtonUi
            key={startTime}
            selectedBackgroundColor={selectedSlotBackgroundColor}
            onClick={() => onTimeSlotSelect?.(startTime)}
            disabled={!onTimeSlotSelect}
            isSelected={
              !!selectedAvailability &&
              isDatesEqual(selectedDate, selectedAvailability?.date) &&
              selectedTimeSlot === startTime
            }
            type="button"
          >
            {secondsToHours(startTime, timeFormat)}
            {eventType === 'GROUP' && (
              <span>{getTextForSlotsLeft(remainingSlots)}</span>
            )}
          </TimeSlotButtonUi>
        ))}
      </TimeSlotListUi>
    </TimeSlotsWrapperUi>
  )
}
